import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& img': {
      width: '100%',
      height: '100%',
      verticalAlign: 'inherit',
      objectFit: 'contain',
    },
  },

  header: {
    display: 'flex',
  },

  headerIcon: {
    marginRight: theme.spacing(1.875),
    height: theme.spacing(2.5),
    width: theme.spacing(3.125),
    alignSelf: 'center',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
}));
